import { useState, useEffect, useRef } from "react";
import axios from "axios";

const rssUrl = "https://medium.com/feed/@nopsa.ventures";
const ARTICLES_COUNT = 6;
const baseUrl = `https://api.rss2json.com/v1/api.json?rss_url=${rssUrl}&count=${ARTICLES_COUNT}${
  process.env.REACT_APP_RSS2JSON_API_KEY
    ? `&api_key=${process.env.REACT_APP_RSS2JSON_API_KEY}`
    : ""
}`;

export const Blog = () => {
  const [articleData, setArticleData] = useState(null);
  const fetchedRef = useRef(false);

  const getData = async () => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    try {
      const response = await axios.get(`${baseUrl}&t=${Math.floor(Date.now() / 1000)}`);
      setArticleData(response.data.items || []);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Blog feed fetch failed", error?.response?.status || error);
      }
      setArticleData([]);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div id="blog">
      <div className="text-center">
        <div className="container">
          <div className="row">
            <div className="section-title" style={{ marginTop: "12px", marginBottom: "18px" }}>
              <h2>Latest Articles</h2>
            </div>

            <div className="row">
              <div className="MediumArticles" style={{ margin: "2vh 0", color: "#232E44" }}>
                {articleData !== null ? (
                  <div className="container">
                    <div className="row">
                      {articleData.slice(0, ARTICLES_COUNT).map((item, index) => {
                        // Fallback to first image in the article content when thumbnail is missing
                        const fallbackUrl =
                          item.content?.match(/<img[^>]+src="([^">]+)"/)?.[1];
                        return (
                          <div key={index} className="col-lg-4 col-md-6" style={{ marginBottom: "24px", display: "flex" }}>
                            <a
                              className="card h-100"
                              href={item.link}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                margin: "0.75vh",
                                borderRadius: "12px",
                                overflow: "hidden",
                                boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
                                display: "flex",
                                flexDirection: "column",
                                textDecoration: "none",
                                color: "#0c1221",
                                minHeight: "370px",
                                height: "220px"
                              }}
                            >
                              {(item.thumbnail || fallbackUrl) && (
                                <div
                                  className="card-img-top"
                                  style={{
                                    height: "240px",
                                    overflow: "hidden",
                                    borderRadius: "12px 12px 0 0",
                                  }}
                                >
                                  <img
                                    src={item.thumbnail || fallbackUrl}
                                    alt={item.title}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              )}
                              <div
                                className="card-body"
                                style={{
                                  overflow: "hidden",
                                  borderRadius: "0 0 12px 12px",
                                  minHeight: "140px",
                                  padding: "12px 14px 12px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  gap: "4px"
                                }}
                              >
                                <h5
                                  className="card-title"
                                  style={{
                                    color: "#0c1221",
                                    fontSize: "1.3rem",
                                    textDecoration: "none",
                                    fontWeight: 400,
                                    lineHeight: 1.35,
                                    fontFamily: '"Space Grotesk", "DM Sans", sans-serif',
                                    letterSpacing: "0.01em",
                                  }}
                                >
                                  {item.title}
                                </h5>
                                {Array.isArray(item.categories) && item.categories.length > 0 && (
                                  <div style={{ marginTop: "6px" }}>
                                    {item.categories.map((cat, catIndex) => (
                                      <span
                                        key={`${cat}-${catIndex}`}
                                        style={{
                                          color: "#000000",
                                          fontSize: "12px",
                                          textDecoration: "none",
                                          fontFamily: '"DM Sans", "Inter", system-ui, sans-serif',
                                          letterSpacing: "0.01em",
                                        }}
                                      >
                                        #{cat}
                                        {catIndex < item.categories.length - 1 ? ", " : ""}
                                      </span>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </a>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <span />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
